import React from "react";
import "./TheFooter.scss";

import logoSplat from "../../assets/img/logo-splat.svg";
import vk from "./assets/vk.svg";
import ok from "./assets/ok.png";
import agrees from "./assets/agrees.pdf";
import rules from "./assets/rules.pdf";

const TheFooter = () => {
  return (
    <footer className="footer">
      <div className="scheme">
        <div className="footer-content">
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://clc.to/_IJwiQ"
            className="footer__logo"
          >
            <img src={logoSplat} alt="Логотип: SPLAT" />
          </a>

          <div className="footer__document-links">
            <a href={rules} download title="скачать">
              Правила акции
            </a>
            <a href={agrees} download title="скачать">
              Политика конфиденциальности
            </a>
            <a href="mailto: actions@splat.ru">Напишите нам</a>
          </div>

          <div className="footer__socials">
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="https://clc.to/oNzQhw"
            >
              <img src={vk} alt="Социальная сеть вконтакте" />
            </a>
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="https://clc.to/fXDJtA"
            >
              <img src={ok} alt="Социальная сеть одноклассники" />
            </a>
          </div>

          <div className="footer__copyright">© SPLAT 2022</div>
        </div>
      </div>
    </footer>
  );
};

export default TheFooter;
